export const GET_MEDIA_ITEMS_BY_TYPES_REQUEST = 'GET_MEDIA_ITEMS_BY_TYPES_REQUEST';
export const GET_MEDIA_ITEMS_BY_TYPES_SUCCESS = 'GET_MEDIA_ITEMS_BY_TYPES_SUCCESS';
export const GET_MEDIA_ITEMS_BY_TYPES_ERROR = 'GET_MEDIA_ITEMS_BY_TYPES_ERROR';
